module.exports = __webpack_public_path__ + "img/send-comment.14305807.svg";